import type { TaskSummary } from "@/api/tasks";

/**
 * The specific machine model for the Machine-type column. POC's "machine type"
 * is the machine key/model (e.g. "824 MSPe", "A240-Bi"), NOT the product
 * category ("Servo-Electric") that `solutionMachineType` holds. We show the
 * frozen solution's display name, falling back to its product id/code, then a
 * dash when neither is set (a task with no snapshot yet).
 */
export function machineLabel(
  t: Pick<TaskSummary, "solutionName" | "solutionProductId">,
): string {
  return t.solutionName || t.solutionProductId || "—";
}
